import { gql, useFragment } from "@apollo/client";

// Style
import style from "./accordion.module.scss";

// Constants
import { accordionBlock } from "@/constants/constants";

// Components
import Container from "@/components-layout/container/container";
import ModuleSettings from "@/components-modules/module-settings/module-settings";
import AbaIcon from "@/components/aba-icon/aba-icon";

function handleClick(e) {
  const item = e.currentTarget;
  const parent = item.parentElement;
  const content = item.nextSibling;
  const isOpen = parent.attributes?.["data-open"]?.value;
  const toggle = isOpen === "false" ? true : false;

  item.ariaExpanded = toggle;
  parent.setAttribute("data-open", toggle);

  toggle ? content.removeAttribute("inert") : content.setAttribute("inert", "");
}

export default function Accordion({ module }) {
  // - Fragment
  const { complete, data } = useFragment({
    fragment: Accordion.fragments.module,
    fragmentName: "AccordionFragment",
    from: {
      __typename: module.__typename,
      id: module.id,
    },
  });

  if (!complete) {
    return;
  }

  // -- If Hide Module -- //
  if (data.accordionBlockModuleSettings.hideModule) {
    return;
  }

  // - Variables
  const moduleSettings = data.accordionBlockModuleSettings;
  const accItems = data.accordionList;
  const rowWidth = data.customRowWidth;
  const numItems = "";

  const labelID = null;
  let labelClasses = "";
  if (data.labelBorder) {
    labelClasses = " add-padding has-border";
  } else if (data.labelBgColor) {
    labelClasses = " add-padding";
  }

  // TODO:: Implement all style vars

  let labelStyle = null;
  let iconStyle = null;

  const contentID = null;
  let contentClasses = null;
  if (data.contentBorder) {
    contentClasses = " add-padding has-border";
  } else if (data.contentBgColor) {
    contentClasses = " add-padding";
  }
  let contentStyle = null;

  // TODO:: Implement function
  //   function getIcon(type) {
  //     if (data.iconType === "pm_thin") {
  //       // <i class='fa-regular fa-plus active'></i>
  //       // <i class='fa-regular fa-minus if ( $open ) { echo ' active'; }'></i>
  //     } else if (data.iconType === "pm_fill") {
  //       // <i class='fa-regular fa-plus active'></i>
  //     } else {
  //       // <i class='fa-solid fa-chevron-down active'></i>
  //     }

  //     return icon;
  //   }

  return (
    <section
      id={moduleSettings.module_id}
      //   className={`moduleAccordion ${style.moduleAccordion} ${
      //     moduleSettings.classes ? moduleSettings.classes : ""
      //   }`}

      className="moduleAccordion"
      preset={data.presetModule && data.presetModule[0]}
    >
      <ModuleSettings settings={moduleSettings} wide={data.isWide} />

      <Container>
        <div
          className="accordionItems"
          {...(rowWidth && { style: { width: `${rowWidth}` } })}
        >
          {accItems &&
            accItems.map((item, i) => {
              const { open, label, labelTag, content } = item;
              const inert = !open && "inert";
              return (
                <div
                  //   className={
                  //     style.accordionItem + " " + (!open && style.closed)
                  //   }
                  className={style.accordionItem}
                  data-open={open ? "true" : "false"}
                  key={i}
                >
                  <button
                    id={labelID}
                    className={style.label + labelClasses}
                    aria-expanded="false"
                    aria-controls={contentID}
                    // {...(labelStyle && { style: labelStyle })}
                    // style={labelStyle}
                    onClick={handleClick}
                  >
                    <h2>{label}</h2>
                    {/* TODO:: implement title tag */}

                    <div
                      className={style.iconContainer}
                      data-icon-type={data.iconType}
                      // style={iconStyle}
                    >
                      {/* {getIcon(data.iconType)} */}
                      <AbaIcon name={AbaIcon.LIST.chevDown} />
                    </div>
                  </button>

                  <div
                    id={contentID}
                    // className={style.content + `${contentClasses}`}
                    className={style.content}
                    aria-labelledby={labelID}
                    // {...(contentStyle && { style: contentStyle })}
                    // style={contentStyle}

                    {...(numItems > 6 && { role: "region" })}
                    {...(!open && { inert: true })}
                    dangerouslySetInnerHTML={{ __html: content }}
                  />
                </div>
              );
            })}
        </div>
      </Container>
    </section>
  );
}

Accordion.fragments = {
  module: gql`
    fragment AccordionFragment on ${accordionBlock} {
      id
      __typename
        accordionList {
        content
        label
        labelTag
        open
        __typename
        }
        contentBgColor
        contentBorderColor
        contentTextColor
        customContentColors
        customLabelColors
        customRowWidth
        iconColor
        iconType
        labelBgColor
        labelBorder
        labelBorderColor
        labelTextColor
        openAll
        presetModule

      # -- Module General Settings
      accordionBlockModuleSettings {
        ...ModSetFragment @unmask(mode: "migrate")
      }
    }
    ${ModuleSettings.fragments.entry}
  `,
};
